"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalBreakpoints = exports.BREAKPOINTS = exports.DESKTOP_ONLY = exports.PHONE_LANDSCAPE = exports.PHONE_PORTRAIT = exports.TABLET_LANDSCAPE = exports.TABLET_PORTRAIT = exports.TABLET_MAX = exports.MIN_1366 = exports.MAX_1366 = exports.MIN_1280 = exports.MAX_1280 = exports.MIN_1024 = exports.MAX_1024 = exports.MIN_768 = exports.MAX_768 = exports.MIN_640 = exports.MAX_640 = exports.MIN_480 = exports.MAX_480 = exports.MIN_375 = exports.MAX_375 = exports.BREAKPOINT_MIN_MAX = exports.BREAKPOINT_MIN = exports.BREAKPOINT_MAX = exports.AND_PORTRAIT = exports.AND_LANDSCAPE = exports.MEDIA_PRINT = exports.MEDIA_SCREEN = exports.MEDIA_ONLY = exports.MEDIA = void 0;
//media CONST
exports.MEDIA = "@media ";
exports.MEDIA_ONLY = exports.MEDIA + "only ";
exports.MEDIA_SCREEN = exports.MEDIA + "screen ";
exports.MEDIA_PRINT = exports.MEDIA + "print";
exports.AND_LANDSCAPE = " and (orientation: landscape)";
exports.AND_PORTRAIT = " and (orientation: portrait)";
//Helpers
var BREAKPOINT_MAX = function (n, screen) {
    if (screen === void 0) { screen = exports.MEDIA; }
    return screen + "(max-width: " + n + "px)";
};
exports.BREAKPOINT_MAX = BREAKPOINT_MAX;
var BREAKPOINT_MIN = function (n, screen) {
    if (screen === void 0) { screen = exports.MEDIA; }
    return screen + "(min-width: " + n + "px)";
};
exports.BREAKPOINT_MIN = BREAKPOINT_MIN;
var BREAKPOINT_MIN_MAX = function (x, y) { return exports.BREAKPOINT_MIN(x) + " and " + exports.BREAKPOINT_MIN(y, ''); };
exports.BREAKPOINT_MIN_MAX = BREAKPOINT_MIN_MAX;
//SIZE BREAKPOINTS
exports.MAX_375 = exports.BREAKPOINT_MAX(375);
exports.MIN_375 = exports.BREAKPOINT_MIN(376);
exports.MAX_480 = exports.BREAKPOINT_MAX(480);
exports.MIN_480 = exports.BREAKPOINT_MIN(481);
exports.MAX_640 = exports.BREAKPOINT_MAX(640);
exports.MIN_640 = exports.BREAKPOINT_MIN(641);
exports.MAX_768 = exports.BREAKPOINT_MAX(768);
exports.MIN_768 = exports.BREAKPOINT_MIN(769);
exports.MAX_1024 = exports.BREAKPOINT_MAX(1024);
exports.MIN_1024 = exports.BREAKPOINT_MIN(1025);
exports.MAX_1280 = exports.BREAKPOINT_MAX(1280);
exports.MIN_1280 = exports.BREAKPOINT_MIN(1281);
exports.MAX_1366 = exports.BREAKPOINT_MAX(1366);
exports.MIN_1366 = exports.BREAKPOINT_MIN(1367);
//ALIASES.
exports.TABLET_MAX = exports.MAX_1366;
exports.TABLET_PORTRAIT = exports.MAX_768 + exports.AND_PORTRAIT;
exports.TABLET_LANDSCAPE = exports.MAX_1024 + exports.AND_LANDSCAPE;
exports.PHONE_PORTRAIT = exports.MAX_375 + exports.AND_PORTRAIT;
exports.PHONE_LANDSCAPE = exports.MAX_640 + exports.AND_LANDSCAPE;
exports.DESKTOP_ONLY = exports.MIN_1366;
exports.BREAKPOINTS = { xxs: 375, xs: 480, sm: 640, md: 768, lg: 1024, xl: 1280, xxl: 1366 };
var PortalBreakpoints = /** @class */ (function () {
    function PortalBreakpoints(nonStandard, cssPrefix) {
        if (nonStandard === void 0) { nonStandard = exports.BREAKPOINTS; }
        if (cssPrefix === void 0) { cssPrefix = "ezd-portal"; }
        this._breakpoints = nonStandard;
        this.cssPrefix = cssPrefix;
    }
    Object.defineProperty(PortalBreakpoints.prototype, "MAX_XXS", {
        get: function () {
            return exports.BREAKPOINT_MAX(this._breakpoints.xxs);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MIN_XXS", {
        get: function () {
            return exports.BREAKPOINT_MIN(this._breakpoints.xxs + 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MAX_XS", {
        get: function () {
            return exports.BREAKPOINT_MAX(this._breakpoints.xs);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MIN_XS", {
        get: function () {
            return exports.BREAKPOINT_MIN(this._breakpoints.xs + 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MAX_S", {
        get: function () {
            return exports.BREAKPOINT_MAX(this._breakpoints.sm);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MIN_S", {
        get: function () {
            return exports.BREAKPOINT_MIN(this._breakpoints.sm + 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MAX_M", {
        get: function () {
            return exports.BREAKPOINT_MAX(this._breakpoints.md);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MIN_M", {
        get: function () {
            return exports.BREAKPOINT_MIN(this._breakpoints.md + 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MAX_L", {
        get: function () {
            return exports.BREAKPOINT_MAX(this._breakpoints.lg);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MIN_L", {
        get: function () {
            return exports.BREAKPOINT_MIN(this._breakpoints.lg + 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MAX_XL", {
        get: function () {
            return exports.BREAKPOINT_MAX(this._breakpoints.xl);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MIN_XL", {
        get: function () {
            return exports.BREAKPOINT_MIN(this._breakpoints.xl + 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MAX_XXL", {
        get: function () {
            return exports.BREAKPOINT_MAX(this._breakpoints.xxl);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MIN_XXL", {
        get: function () {
            return exports.BREAKPOINT_MIN(this._breakpoints.xxl + 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "DESKTOP_ONLY", {
        get: function () {
            return this.MIN_XXL;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "TABLET_MAX", {
        get: function () {
            return this.MAX_XXL;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "TABLET_PORTRAIT", {
        get: function () {
            return this.MAX_M + exports.AND_LANDSCAPE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "TABLET_LANDSCAPE", {
        get: function () {
            return this.MAX_L + exports.AND_LANDSCAPE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "PHONE_PORTRAIT", {
        get: function () {
            return this.MAX_XXS + exports.AND_PORTRAIT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "PHONE_LANDSCAPE", {
        get: function () {
            return this.MAX_S + exports.AND_LANDSCAPE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MEDIA_PRINT", {
        get: function () {
            return exports.MEDIA_PRINT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PortalBreakpoints.prototype, "MEDIA_SCREEN", {
        get: function () {
            return exports.MEDIA_SCREEN;
        },
        enumerable: false,
        configurable: true
    });
    return PortalBreakpoints;
}());
exports.PortalBreakpoints = PortalBreakpoints;
//# sourceMappingURL=breakpoints.js.map